import { useNavigate } from "react-router-dom";

const Header = ({ mode, updateMessage, addMessage, homeLink, homeText }) => {
  const navigate = useNavigate();

  const title =
    mode === "edit"
      ? updateMessage
      : mode === "view"
      ? `View ${homeText}`
      : addMessage;

  const crumbLabel =
    mode === "edit" ? "Update" : mode === "view" ? "View" : "Add";

  return (
    <div className="ems-form-hd">
      <h1 className="ems-page-title">{title}</h1>
      <nav className="ems-crumb" aria-label="breadcrumb">
        <button className="ems-crumb-link" onClick={() => navigate(homeLink)}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round"
            strokeLinejoin="round" style={{ flexShrink: 0 }}>
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          {homeText}
        </button>
        <span className="ems-crumb-sep" aria-hidden="true">›</span>
        <span className="ems-crumb-current">{crumbLabel}</span>
      </nav>
      <div className="ems-section-divider"></div>
    </div>
  );
};

export default Header;
